import { render, staticRenderFns } from "./shipmentDraw.vue?vue&type=template&id=448a3cce&scoped=true&"
import script from "./shipmentDraw.vue?vue&type=script&lang=js&"
export * from "./shipmentDraw.vue?vue&type=script&lang=js&"
import style0 from "./shipmentDraw.vue?vue&type=style&index=0&id=448a3cce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448a3cce",
  null
  
)

export default component.exports